import type React from 'react';
import { useRef } from 'react';

export const useContainerRef = (): React.RefObject<HTMLDivElement> => useRef<HTMLDivElement>(null);

export const useInnerSpanRef = (): React.RefObject<HTMLSpanElement> =>
  useRef<HTMLSpanElement>(null);
